// @flow

import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_AUTH_URL ) {
  API_URL = process.env.REACT_APP_API_AUTH_URL;
}


// Requests
const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  },

  delete: (url: string) => {
    return axios.delete(API_URL + url);
  },

  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  },

  put: (url: string, body: any, headers: any) => {
    return axios.put(API_URL + url, body, headers);
  }
};

const AuthAPI = {
  loginPost: (email: string, password: string, remember: bool) => {
    return requests.post(RoutesAPI.auth_login_path(), { email: email, password: password, remember_me: remember })
  },

  editPassword: (oldPassword: string, newPassword: string, newPasswordConfirmation: string) => {
    return requests.put(RoutesAPI.auth_update_password_path(), { password: newPasswordConfirmation, password_confirmation: newPassword, current_password: oldPassword });
  },

  registerPost: (email: string, password: string, password_confirmation: string, confirm_success_url: string) => {
    return requests.post(RoutesAPI.auth_register_path(), { email: email, password: password, password_confirmation: password_confirmation, confirm_success_url: confirm_success_url })
  },

  logoutPost: () => {
    return requests.delete(RoutesAPI.auth_logout_path())
  },

  requestPassword: (email: string, redirect_url: string) => {
    return requests.post(RoutesAPI.auth_request_password_path(), { email: email, redirect_url: redirect_url })
  },

  resetPassword: (password: string, reset_password_token: string, headers: any) => {
    return requests.put(RoutesAPI.auth_reset_password_path(), { password: password, password_confirmation: password, reset_password_token: reset_password_token }, { headers: headers })
  },

  validateTokenPost: (headers: any) => {
    return requests.get(RoutesAPI.auth_validate_token(), headers)
  },

  confirmEmail: (email: string, redirect_url: string) => {
    return requests.post(RoutesAPI.auth_email_confirmation_path(), { email: email, redirect_url: redirect_url, confirm_success_url: redirect_url })
  },

  unlockAccount: (email: string, redirect_url: string) => {
    return requests.post(RoutesAPI.auth_unlock_path(), { api_starfish_user: { email: email, redirect_url: redirect_url } })
  },

  unlockAccountByToken: (unlock_token: string) => {
    return requests.get(RoutesAPI.auth_unlock_path() + '?unlock_token=' + unlock_token, {})
  },

  redirectUrl: (origin: string) => {
    return RoutesAPI.auth_omniauth_redirect_url(origin)
  }
}

export default AuthAPI;



// WEBPACK FOOTER //
// ./src/api/AuthAPI.js